import React, { createContext, useContext, useState } from "react"
import { useNavigate } from "react-router-dom"

const NavigationBlockContext = createContext(null)

export const NavigationBlockProvider = ({ children }) => {
  const [isBlocked, setIsBlocked] = useState(false)
  const [attemptedNavigation, setAttemptedNavigation] = useState([false, null])
  const navigate = useNavigate()

  const resetAttemptedNavigation = () => {
    setAttemptedNavigation([false, null])
  }

  const block = () => {
    setIsBlocked(true)
  }

  const unblock = () => {
    setIsBlocked(false)
    resetAttemptedNavigation()
  }

  const resumeBlockedNavigation = () => {
    if (attemptedNavigation[0]) {
      if (typeof attemptedNavigation[1] === "function") {
        attemptedNavigation[1]()
      } else {
        navigate(attemptedNavigation[1])
      }
    }
  }

  return (
    <NavigationBlockContext.Provider
      value={{
        isBlocked,
        attemptedNavigation,
        resetAttemptedNavigation,
        setAttemptedNavigation,
        block,
        unblock,
        resumeBlockedNavigation,
      }}
    >
      {children}
    </NavigationBlockContext.Provider>
  )
}

export const useNavigationBlock = () => useContext(NavigationBlockContext)
